import React from 'react'
import { AccDriverRates } from './AccDriverRates'

export const DriverRateContent = ({data}) => {

    const renderBaseRates = () => {
        return <AccDriverRates data={data} />;
    }
  return (
    <div>
      {renderBaseRates()}
    </div>
  )
}
